import React from "react";
import ReactECharts from "echarts-for-react";

import { formatDate } from "../../utils/helper";

interface PeakUsageChartProps {
  dataArray: Array<{
    ts: string;
    IP_KWH?: string;
    IP_Current?: string;
    [key: string]: any;
  }>;
}

const PeakUsageChart: React.FC<PeakUsageChartProps> = ({ dataArray }) => {
  const options = {
    tooltip: {
      trigger: "axis",
      backgroundColor: "#181B25",
      borderWidth: 0,
      textStyle: {
        color: "#fff",
        fontSize: 12,
      },
    },
    xAxis: {
      type: "category",
      data: dataArray?.map((item) => {
        return `${formatDate(new Date(item?.ts), "DD/MM/YYYY HH:mm:ss")}`;
      }),
      axisLabel: {
        color: "#181B25",
        fontSize: 11,
        fontWeight: 400,
      },
      name: "Times",
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: "{value}",
        color: "#5F6368",
        fontSize: 9,
        fontWeight: 400,
        lineHeight: 11,
        letterSpacing: 0.2,
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "#e0e0e0",
          type: "dashed",
        },
      },
      name: "Usage",
    },
    grid: {
      left: "5%",
      right: "7%",
      bottom: "6%",
      containLabel: true,
    },
    series: [
      {
        name: "IP_KWH",
        type: "line",
        data: dataArray?.map((item) => parseFloat(item.IP_KWH || "0")),
        lineStyle: {
          color: "#ff9b30",
          width: 2,
        },
        itemStyle: {
          color: "#ff9b30",
        },
        symbol: "circle",
        symbolSize: 6,
      },
      {
        name: "IP_Current",
        type: "line",
        data: dataArray?.map((item) => parseFloat(item.IP_Current || "0")),
        lineStyle: {
          color: "#1976d2",
          width: 2,
        },
        itemStyle: {
          color: "#1976d2",
        },
        symbol: "circle",
        symbolSize: 6,
      },
    ],
    toolbox: {
      feature: {
        saveAsImage: {},
        restore: {},
        dataView: {},
        magicType: { type: ["line", "bar"] },
        brush: { type: ["rect", "polygon", "clear"] },
        dataZoom: {},
      },
    },
  };

  return <ReactECharts option={options} />;
};

export default PeakUsageChart;
